import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ArchitectsOfYourFinancialFuture from "./sections/ArchitectsOfYourFinancialFuture";
import TheProFlowProcess from "./sections/TheProFlowProcess";
import EngineeredForGrowth from "./sections/EngineeredForGrowth";
import ClinicalExcellence from "./sections/ClinicalExcellence";
import MeasurableImpact from "./sections/MeasurableImpact";
import VoicesOfAuthority from "./sections/VoicesOfAuthority";
import ClaimYourDigitalSpace from "./sections/ClaimYourDigitalSpace";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ArchitectsOfYourFinancialFuture />
      <TheProFlowProcess />
      <EngineeredForGrowth />
      <ClinicalExcellence />
      <MeasurableImpact />
      <VoicesOfAuthority />
      <ClaimYourDigitalSpace />
      <Footer />
    </div>;
}